document.addEventListener("DOMContentLoaded", function () {
	// add style to landing page LSI Content Blocks
	const parentLeft = document.querySelectorAll(".left-align");
	parentLeft.forEach(function (element) {
		element.parentElement.classList.add("block-content-left");
	});

	const parentRight = document.querySelectorAll(".right-align");
	parentRight.forEach(function (element) {
		element.parentElement.classList.add("block-content-right");
	});

	const textOnlyParent = document.querySelectorAll(".text-only");
	textOnlyParent.forEach(function (element) {
		element.parentElement.classList.add("text-only-content");
	});
});
